import { format, isBefore } from 'date-fns';
import memoizeOne from 'memoize-one';

import { toClientUTCDateFormat } from '../../components/Containers/PurchaseForm/utils';
import { SECOND } from '../../constants/dateTime';
import { TimeRangeQueryResponse } from '../../types/web3/time';

// time in ethereum is counted in seconds from epoch to locally timezoned date
export const blockTimestampToLocalDate = (blockTimeStamp: number): Date => {
  const milis = Math.round(blockTimeStamp * SECOND);
  return new Date(milis);
};

export const formatBlockTimestamp = (
  blockTime: Date,
  formatString: string = 'dd-MM-yyyy hh:mm:ss aaa',
) => {
  return format(blockTime, formatString); // 13-01-2022 4:17:00 pm
};

// Returns information on a time range
export const timeRangeQuery = memoizeOne(
  (closeDate: string, startDate: string): TimeRangeQueryResponse => {
    const closing = new Date(toClientUTCDateFormat(closeDate));
    const launch = new Date(toClientUTCDateFormat(startDate));
    const now = new Date();
    const started = startDate ? isBefore(launch, now) : false;
    const closed = closeDate ? isBefore(closing, now) : true;
    return {
      started,
      closed,
      isRunning: started && !closed,
    };
  },
);
